import { api } from '../utils/request';

// 定义用户相关的 API 接口
export const APIWeb = {

  // 检查用户是否已验证
  checkVerified: () => {
    return api.post<checkVerifiedResponse>('/web/member/check_verified');
  },
  // 发送验证码
  sendCode: (params: SendCodeRequest) => {
    return api.post<SendCodeResponse>('/web/member/send_code', params);
  },

  // 注册
  register: (params: RegisterRequest) => {
    return api.post<RegisterResponse>('/wpay/web/member/register', params);
  },

  // 登录
  login: (params: LoginRequest) => {
    return api.post<LoginResponse>('/web/login/login', params);
  },

  // Google登录
  googleLogin: (params: GoogleLoginRequest) => {
    return api.post<GoogleLoginResponse>('/web/login/google_login', params);
  },

  // 获取用户信息
  getUserInfo: () => {
    return api.post<MemberInfoResponse>('/wpay/web/member/info');
  },

  // 获取可充值的链
  getRechargeableChains: () => {
    return api.post<any>('/web/cobo/token_select');
  },

  // 获取钱包地址
  getAddress: (params: MemberAddressRequest) => {
    return api.post<MemberAddressResponse>('/web/member/address', params);
  },

  // 获取充值流水
  getDepositRecords: (params: TransactionListRequest) => {
    return api.post<TransactionListResponse>('/web/cobo/list', params);
  },


  // 获取资产流水列表
  getAssetFlowList: (params: AssetFlowListRequest) => {
    return api.post<AssetFlowListResponse>('/web/member/asset_flow_list', params);
  },

  // kyc申请
  applyKyc: (params: ApplyKycRequest) => {
    return api.post<any>('/web/kyc/apply', params);
  },

  // kyc详情
  kycDetail: (params: { id: number }) => {
    return api.post<KycDetailResponse>('/web/kyc/detail', params);
  },

  // kyc修改
  kycUpdate: (params: ApplyKycRequest & { id: number }) => {
    return api.post<any>('/web/kyc/update', params);
  },

  // 文件上传
  s3uploadFile: (params: UploadFileRequest) => {
    return api.post<UploadFileResponse>('/web/common/s3_upload_url', params);
  },


  // 获取谷歌验证器二维码
  getGoogleAuthQRCode: () => {
    return api.post<GoogleAuthQRCodeResponse>('/web/member/google_auth_qr_code');
  },

  // 绑定谷歌验证器
  bindGoogleAuth: (params: BindGoogleAuthRequest) => {
    return api.post<any>('/web/member/bind_google_auth', params);
  },

  // 绑定邮箱
  bindEmail: (params: bindEmailRequest) => {
    return api.post<any>('/web/member/bind_email', params);
  },

  // 绑定手机
  bindPhone: (params: bindPhoneRequest) => {
    return api.post<any>('/web/member/bind_phone', params);
  },

  // 变更邮箱
  changeEmail: (params: ChangeEmailRequest) => {
    return api.post<any>('/web/member/change_contact', params);
  },

  // 更改旧Account校验Code
  verifyOldAccountCode: (params: VerifyAccountCodeRequest) => {
    return api.post<VerifyAccountCodeResponse>('/web/member/verify_code', params);
  },

  // 变更新Account校验Code
  verifyNewAccountCode: (params: ChangeContactRequest) => {
    return api.post<any>('/web/member/change_contact', params);
  },

  // 忘记密码
  forgotPassword: (params: ForgotPasswordRequest) => {
    return api.post<any>('/web/member/password_reset', params);
  },

  // 忘记密码校验Code
  verifyForgotPasswordCode: (params: VerifyAccountCodeRequest) => {
    return api.post<VerifyAccountCodeResponse>('/web/member/verify_code_un_login', params);
  },

  // 添加收款账户
  addReceivingAccount: (params: AddReceivingAccountRequest) => {
    return api.post<any>('/web/payment_account/add', params);
  },

  // 收款账户列表
  getReceivingAccountList: (params: GetReceivingAccountListRequest) => {
    return api.post<GetReceivingAccountListResponse>('/web/payment_account/list', params);
  },

  // 开卡添加邮寄地址
  addShippingAddress: (params: AddShippingAddressRequest) => {
    return api.post<any>('/web/shipping_address/add', params);
  },

  // 查看开卡邮寄地址
  getShippingAddress: () => {
    return api.post<GetShippingAddressResponse>('/web/shipping_address/list');
  },

  // 兑换
  exchange: (params: ExchangeRequest) => {
    return api.post<any>('/web/exchange/exchange', params);
  },

  // 获取兑换记录
  getExchangeRecord: (params: GetExchangeRecordRequest) => {
    return api.post<GetExchangeRecordResponse>('/web/exchange/list', params);
  },

  // 推广中心
  getPromotionCenter: () => {
    return api.post<GetPromotionCenterResponse>('/wpay/web/member/invite_center');
  },

  // 推广列表
  getPromotionList: (params: GetPromotionListRequest) => {
    return api.post<GetPromotionListResponse>('/wpay/web/member/direct_invite_list', params);
  },
  // 商家配置
  getMerchantConfig: () => {
    return api.post<GetBusinessConfigResponse>('/web/merchant/config');
  },

  // 汇款
  remittance: (params: RemittanceRequest) => {
    return api.post<any>('/web/transfer/create', params);
  },

  // 汇款记录
  getRemittanceRecord: (params: GetRemittanceRecordRequest) => {
    return api.post<GetRemittanceRecordResponse>('/web/transfer/list', params);
  },

  // 检测账户注册状态
  checkAccountStatus: (params: CheckAccountStatusRequest) => {
    return api.post<CheckAccountStatusResponse>('/web/member/check_account', params);
  },

  // 检查邀请码
  checkInviteCode: (params: VerifyInviteCodeRequest) => {
    return api.post<VerifyInviteCodeResponse>('/wpay/web/member/verify_invite_code', params);
  },

  // 领取推广收益
  getPromotionIncome: (params: GetPromotionIncomeRequest) => {
    return api.post<any>('/wpay/web/member/claim_wusd', params);
  },
  // 编辑用户信息（使用 multipart/form-data 格式）
  editUserInfo: (params: EditUserInfoRequest) => {
    const formData = new FormData();

    // 添加昵称
    if (params.nickname) {
      formData.append('nickname', params.nickname);
    }

    // 添加头像 URL
    if (params.avatar) {
      formData.append('avatar', params.avatar);
    }

    // axios 会自动设置 Content-Type 为 multipart/form-data
    return api.post<any>('/web/member/profile', formData);
  },

  // 用户转账
  balanceTransfer: (params: BalanceTransferRequest) => {
    return api.post<any>('/web/member/balance_transfer', params);
  },

  // 用户互转记录
  getTransferRecord: (params: GetTransferRecordRequest) => {
    return api.post<GetTransferRecordResponse>('/web/member/transfer_list', params);
  },


  // 首页用户所有流水
  getAllRecord: (params: getAllRecordRequest) => {
    return api.post<getAllRecordResponse>('/web/member/asset_flow_list', params);
  },

  // v2接口：虚拟卡开卡
  applyVirtualCardV2: (params: ApplyCardV2Request) => {
    return api.post<CardApplyResponse>('/web/card/apply', params);
  },
  // v2接口：实体卡开卡
  applyPhysicalCardV2: (params: ApplyPhysicalCardV2Request) => {
    return api.post<CardApplyResponse>('/web/card/physical_card_apply_v2', params);
  },
  // V2接口：用户持卡列表（虚拟卡和实体卡）
  getUserCardListV2: (params?: getUserCardListV2Request) => {
    return api.post<getUserCardListV2Response>('/web/card/list', params);
  },

  // V2接口：消费记录
  getUserCardConsumptionRecordV2: (params: getUserCardConsumptionRecordRequest) => {
    return api.post<getUserCardConsumptionRecordResponse>('/web/card/transactions', params);
  },

  // V2接口：冻结虚拟卡
  freezeVirtualCardV2: (params: freezeVirtualCardRequest) => {
    return api.post<any>('/web/card/freeze_v2', params);
  },

  // V2接口：解冻虚拟卡
  unfreezeVirtualCardV2: (params: unfreezeVirtualCardRequest) => {
    return api.post<any>('/web/card/unfreeze_v2', params);
  },

  // v2接口：获取虚拟卡详情
  getVirtualCardDetailV2: (params: getVirtualCardDetailRequest) => {
    return api.post<getVirtualCardDetailResponse>('/web/card/info', params);
  },

  // v2接口：虚拟卡充值
  virtualCardRechargeV2: (params: virtualCardRechargeRequest) => {
    return api.post<virtualCardRechargeResponse>('/web/card/deposit_v2', params);
  },

  // v2接口：获取消息（简化版）
  getMessageListV2: () => {
    return api.post<getMessageListResponse>('/web/member/activation_code');
  },

  // v2接口：获取持卡人KYC列表
  getCardholderKycListV2: (params: getCardholderKycListV2Request) => {
    return api.post<getCardholderKycListV2Response>('/web/kyc/list', params);
  },

  // v2接口：查看卡片cvv敏感信息
  getCardCvvInfoV2: (params: getCardCvvInfoRequest) => {
    return api.post<getCardCvvInfoResponse>('/web/card/sensitive_info', params);
  },

  // V2接口： 卡产品列表
  getCardProductListV2: () => {
    return api.post<CardProductListResponse>('/web/card/product_list');
  },

  // v2接口：关闭卡片
  closeCardV2: (params: closeCardRequest) => {
    return api.post<any>('/web/card/close', params);
  },

  // v2接口：调整限额
  adjustCardLimitV2: (params: adjustCardLimitV2Request) => {
    return api.post<any>('/web/card/limit_change', params);
  },

  // v2接口：转出
  withdrawCardV2: (params: withdrawCardV2Request) => {
    return api.post<any>('/web/card/withdraw', params);
  },

  // v2接口：激活实体卡
  activatePhysicalCardV2: (params: activatePhysicalCardRequest) => {
    return api.post<any>('/web/card/physical_card_activate', params);
  },

  // v2接口：查询kyc审核状态
  accelerateCardV2: (params: accelerateCardRequest) => {
    return api.post<any>('/web/card/sync_kyc_status', params);
  },

  // v2接口：绑定已有卡
  bindExistingCardV2: (params: bindExistingCardRequest) => {
    return api.post<CardApplyResponse>('/web/card/physical_card_bind', params);
  },

  // v2接口：KYC失败后重新提交（虚拟卡/实体卡）
  reapplyCardKycV2: (params: CardReapplyRequest) => {
    return api.post<any>('/web/card/reapply', params);
  },

  // 转账目标账户校验
  checkTransfer: (params: { target_user_type: string; target_user_info: string }) => {
    return api.post<boolean>('/web/member/check_transfer', params);
  },
  
  // 获取卡片邮寄信息
  getCardShippingInfoV2: (params: {id: number}) => {
    return api.post<getCardShippingInfoResponse>('/web/card/fetch_physical_card_shipping', params);
  },

  // v2接口：绑定下游卡
  bindDownstreamCardV2: (params: bindDownstreamCardRequest) => {
    return api.post<CardApplyResponse>('/web/card/downstream_apply', params);
  },

  // 资产流水表格列表
  getAssetFlowTableList: (params: AssetFlowTableListRequest) => {
    return api.post<AssetFlowTableListResponse>('/web/card/asset_flow_table_list', params);
  },

  // 验证卡片兑换码
  verifyCardRedemptionCode: (params: verifyCardRedemptionCodeRequest) => {
    return api.post<any>('/web/member/verify_redemption_code', params);
  },

  // 验证kyc要素
  verifyKycElements: (params: verifyKycElementsRequest) => {
    return api.post<any>('/web/kyc/verify', params);
  },
};

